export * from './apple-certificate-upload.component';
